import React from "react"
import Image from "gatsby-image"

const PostHero = ({ post }) => {
  const { title, date, tags, keywords, image } = post
  const dateArray = date.split(/[ ,]/).filter((x) => !!x)
  return (
    <div className="box box--invert flex flex-col">
      <div className="body section">
        <div className="text-right mb-32">
          <time className="font-thin text-sm inline-flex flex-col">
            {dateArray.map((date, index) => (
              <div
                className="py-2 border-t first:border-t-0 border-baby-powder"
                key={index}
              >
                {date}
              </div>
            ))}
          </time>
        </div>
        <div className="relative text-right">
          <h1 className="font-heading leading-none mb-16 lg:mb-0 text-right text-6xl lg:text-hero-xl uppercase break-all">
            {title}
          </h1>
        </div>
      </div>
      {image && image.childImageSharp && (
        <Image {...image.childImageSharp} alt={title}></Image>
      )}
    </div>
  )
}

export default PostHero
